//@flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */

const window = require('../../util/window');
const SphericalMercator = require('sphericalmercator');

class Json2texture {
    static get zoom() {
        return 10;
    }
    static coordinates2bbox(coordinates) {
        const bbox = [Infinity, Infinity, -Infinity, -Infinity];
        return coordinates.reduce((bbox, coord) => {
            let minX = bbox[0];
            let minY = bbox[1];
            let maxX = bbox[2];
            let maxY = bbox[3];
            const lng = coord[0];
            const lat = coord[1];
            minX = Math.min(lng, minX);
            minY = Math.min(lat, minY);
            maxX = Math.max(lng, maxX);
            maxY = Math.max(lat, maxY);
            return [minX, minY, maxX, maxY];
        }, bbox);
    }
    constructor(gl, tileSize) {
        this.gl = gl;
        this.tileSize = tileSize;
        this.merc = new SphericalMercator({
            size: tileSize,
        });
    }
    json2texture(geojson, coordinates) {
        const tileSize = this.tileSize;
        let [minX, minY, maxX, maxY] = Json2texture.coordinates2bbox(coordinates);
        [minX, minY] = this.merc.px([minX, minY], Json2texture.zoom);
        [maxX, maxY] = this.merc.px([maxX, maxY], Json2texture.zoom);
        const bboxSize = {
            minX, minY, maxX, maxY
        };
        const canvas = window.document.createElement('canvas');
        canvas.width = tileSize;
        canvas.height = tileSize;
        const ctx = canvas.getContext('2d');
        geojson.features.forEach(feature => {
            this.drawFeature(feature, ctx, bboxSize);
        });
        // window.document.body.appendChild(canvas);
        return this.createTexture(canvas);
        // return this.createTexture(ctx.getImageData(0, 0, tileSize, tileSize));
    }
    createTexture(canvas) {
        const gl = this.gl;
        // const tileSize = this.tileSize;
        const texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        // ä¸ç¥éä¸ºä»ä¹,ä½¿ç¨ image.data è¿ç§åæ³æé®é¢
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, canvas);
        // gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, tileSize, tileSize, 0, gl.RGBA, gl.UNSIGNED_BYTE, imageData.data);
        // gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, tileSize);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        return texture;
    }
    drawFeature(feature, ctx, bboxSize) {
        const geo = feature.geometry;
        const type = geo.type;

        if (type !== 'MultiPolygon' && type !== 'Polygon') {
            throw Error('æ°æ®ä¸æ¯ä¸ä¸ªå¤è¾¹å½¢');
        }
        if (geo.coordinates.length === 0)
            return;
        if (type === 'Polygon') {
            geo.coordinates.forEach(coordinates => this.drawPolygon(coordinates, ctx, bboxSize));
        } else if (type === 'MultiPolygon') {
            geo.coordinates.forEach((polygon) => {
                polygon.forEach((coordinates) => {
                    this.drawPolygon(coordinates, ctx, bboxSize);
                });
            });
        }
    }
    drawPolygon(coordinates, ctx, bboxSize) {
        const merc = this.merc;
        const width = bboxSize.maxX - bboxSize.minX;
        const height = bboxSize.maxY - bboxSize.minY;
        const tileSize = this.tileSize;

        ctx.beginPath();
        ctx.fillStyle = "#000000";
        // ctx.strokeStyle = options.lineColor
        // ctx.lineWidth = options.lineWidth
        if (!coordinates || !coordinates.length)
            return;
        for (let i = 0; i < coordinates.length; i++) {
            const lbpx = merc.px([coordinates[i][0], coordinates[i][1]], Json2texture.zoom); // å·¦ä¸è§
            const x = ((lbpx[0] - bboxSize.minX) / width) * tileSize;
            const y = tileSize - ((lbpx[1] - bboxSize.minY) / height) * tileSize;
            if (i === 0)
                ctx.moveTo(x, y);
            else
                ctx.lineTo(x, y);
        }

        ctx.fill();
    }

}

module.exports = Json2texture;
